import React, { useState } from 'react';
import { XIcon, MenuIcon, ChevronDownIcon, LinkedinIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
interface MenuItem {
  title: string;
  url: string;
  children?: MenuItem[];
  onClick?: (e: React.MouseEvent) => void;
}
const urlsWithNewBadge = ['/EDMNetworkFastWire.html', '/SeibuWireEDM.html', '/EDMNetwork.html'];
export function HeaderMobileNav() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileSection, setOpenMobileSection] = useState<string | null>(null);
  const toggleMobileSection = (section: string) => setOpenMobileSection(prev => prev === section ? null : section);
  const mobileMenuItems: MenuItem[] = [{
    title: 'Home',
    url: '/'
  }, {
    title: 'About',
    url: '',
    children: [{
      title: 'About Peak',
      url: '/AboutPeakMachineSales.html'
    }, {
      title: 'FAQ',
      url: '/FrequentlyAskedQuestions.html'
    }, {
      title: 'Industry News',
      url: '/ManufacturingIndustryNews.html'
    }]
  }, {
    title: 'Products',
    url: '',
    children: [{
      title: 'Product Lines',
      url: '',
      children: [{
        title: 'Used Machine Inventory',
        url: '/59m7/used-machines.html'
      }, {
        title: 'Fast Wire EDM – Moly Wire',
        url: '/EDMNetworkFastWire.html'
      }, {
        title: 'Seibu America',
        url: '/SeibuWireEDM.html'
      }, {
        title: 'EDM Network',
        url: '/EDMNetwork.html'
      }, {
        title: 'Spinner Milling & Turning',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'Breton Machine Tools',
        url: '/BretonMachineTools.html'
      }, {
        title: 'Bodor Laser Cutting',
        url: '/BodorLaserCutting.html'
      }]
    }, {
      title: 'Categories',
      url: '',
      children: [{
        title: 'Used Machines',
        url: '/59m7/used-machines.html'
      }, {
        title: 'EDM',
        url: '/59m7/edm.html'
      }, {
        title: 'CNC Milling',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'CNC Turning',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'Laser Cutting',
        url: '/59m7/laser.html'
      }, {
        title: 'Automation',
        url: '/59m7/automation.html'
      }, {
        title: 'EDM Parts & Consumables',
        url: '/QuoteEDMConsumables.html'
      }]
    }]
  }, {
    title: 'Contact',
    url: '',
    children: [{
      title: 'Contact Us',
      url: '/ContactPeakMachineSales.html'
    }, {
      title: 'Selling Used EDM',
      url: '/SellingUsedEDM.html'
    }]
  }];
  const renderBadge = (url: string) => urlsWithNewBadge.includes(url) ? <span className="text-xs bg-orange text-white px-2 py-0.5 rounded ml-1" data-id="element-2719">
        NEW
      </span> : null;
  return <div className="lg:hidden" data-id="element-2720">
      <button onClick={() => setIsMobileMenuOpen(prev => !prev)} className="text-navy p-2" aria-label="Toggle menu" data-id="element-2721">
        {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-2722" /> : <MenuIcon className="w-6 h-6" data-id="element-2723" />}
      </button>

      {/* Expanded Mobile Menu Panel — absolute so it doesn't disrupt parent flex row */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white border-t border-gray-200 max-h-[80vh] overflow-y-auto shadow-lg" data-id="element-2724">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-2725">
            <nav className="flex flex-col space-y-2" data-id="element-2726">
              {mobileMenuItems.map(item => {
            if (!item.children || item.children.length === 0) {
              return <a key={item.title} href={item.url} className="text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-2727">
                      {item.title}
                    </a>;
            }
            const sectionKey = item.title.toLowerCase();
            const isSectioned = item.children.some(child => child.children && child.children.length > 0);
            return <div key={item.title} data-id="element-2728">
                    <button onClick={() => toggleMobileSection(sectionKey)} className="flex items-center justify-between w-full text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-2729">
                      {item.title}
                      <ChevronDownIcon className={`w-4 h-4 transition-transform ${openMobileSection === sectionKey ? 'rotate-180' : ''}`} data-id="element-2730" />
                    </button>

                    {openMobileSection === sectionKey && <>
                        {isSectioned ? <div className="ml-4 space-y-3 mt-2" data-id="element-2731">
                            {item.children.map(section => <div key={section.title} data-id="element-2732">
                                <p className="text-xs font-bold text-gray-500 uppercase mb-2" data-id="element-2733">
                                  {section.title}
                                </p>
                                <div className="space-y-2" data-id="element-2734">
                                  {section.children?.map(leaf => <a key={leaf.title} href={leaf.url} onClick={leaf.onClick} className={`block text-navy hover:text-orange transition-colors py-1 text-sm ${urlsWithNewBadge.includes(leaf.url) ? 'font-medium' : ''}`} data-id="element-2735">
                                      {leaf.title} {renderBadge(leaf.url)}
                                    </a>)}
                                </div>
                              </div>)}
                          </div> : <div className="ml-4 space-y-2 mt-2" data-id="element-2736">
                            {item.children.map(child => <a key={child.title} href={child.url} className="block text-navy hover:text-orange transition-colors py-1" data-id="element-2737">
                                {child.title}
                              </a>)}
                          </div>}
                      </>}
                  </div>;
          })}

              <div className="flex items-center space-x-4 pt-4 border-t border-gray-200" data-id="element-2738">
                <a href="https://www.linkedin.com/company/peak-machine-sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="LinkedIn" data-id="element-2739">
                  <LinkedinIcon className="w-5 h-5" data-id="element-2740" />
                </a>
                <a href="https://www.facebook.com/PeakMachineSales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Facebook" data-id="element-2741">
                  <FacebookIcon className="w-5 h-5" data-id="element-2742" />
                </a>
                <a href="https://www.instagram.com/peak_machine_sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Instagram" data-id="element-2743">
                  <InstagramIcon className="w-5 h-5" data-id="element-2744" />
                </a>
                <a href="https://www.youtube.com/channel/UCG3x08N2riAd1G2e9-driYA" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="YouTube" data-id="element-2745">
                  <YoutubeIcon className="w-5 h-5" data-id="element-2746" />
                </a>
              </div>
            </nav>
          </div>
        </div>}
    </div>;
}